import { Modal, Progress, Result, Typography } from 'antd';
import React, { useState } from 'react';
import Sheet from 'react-modal-sheet';
import { CloseOutlined } from '@ant-design/icons';
import {
  checkStatusOfConsent,
  getAccounts,
  getData,
} from '../../Services/PFMClient/DashboardService';
import {
  getReferenceId,
  getUserId,
  setAccounts,
} from '../../Utils/storageUtils';
import { getUserName, greetUser } from '../../Utils/utils';
import Calendar from './Calendar';
import DetailedTransaction from './DetailedTransaction';
import GoalDetails from './Goals/goalDetails';
import Home from './Home';
import styles from './index.module.css';
import LiabilitiesView from './Liabilities';
import Portfolio from './Portfolio';
import Spends from './Spends';
import WhyAA from './WhyAA';
import Garage from './Garage';
import { getGoals } from '../../Utils/utils';
import Nudge from '../../Models/Nudge';
import NudgeDetails from './Nudges/NudgeDetails';

export enum DASHBOARDPAGES {
  HOME,
  SPENDS,
  PORTFOLIO,
  CALENDAR,
  LIABILITIES,
  GOALDETAILS,
  GARAGE,
}
export const DashboardContext = React.createContext({});
const Dashboard: React.FC = () => {
  const [dashBoardCurrentPage, setDashboardCurrentPage] = useState<any>(
    DASHBOARDPAGES.HOME
  );
  const [goals, setGoals] = useState<any>(getGoals());
  const [listOfItemsBudget, setListOfItemsBudget] = useState<any[]>([
    { name: 'UTILITIES', budget: '4000', spend: '3000' },
    { name: 'SHOPPING', budget: '3000', spend: '3000' },
  ]);
  const [nudgeDrawerOpen, setNudgeDrawerOpen] = useState(false);
  const [drawerNudge, setDrawerNudge] = useState<Nudge | undefined>(undefined);

  const [isLoading, setIsLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [type, setType] = useState('');
  const [isWhyAAModalOpen, setIsWhyAAModalOpen] = useState<boolean>(false);
  const [defaultTab, setDefaultTab] = useState('1');
  const [defaultHomeTab, setDefaultHomeTab] = useState('assets');
  const [currentMetaData, setCurrentMetaData] = useState<any>(undefined);
  const [isDetailedTransactionSheetOpen, setIsDetailedTransactionSheetOpen] =
    useState(false);
  const [goalName, setGoalName] = useState('Car');
  const [pausedAccounts, setPausedAccounts] = useState(['0137', '0139']);
  const [revokedAccounts, setRevokedAccounts] = useState([]);

  const [portfolioList, setPortfolioList]: any = useState<any>([
    'banks',
    'mutualFunds',
    'stocks',
    'deposits',
  ]);
  const [percent, setPercent] = useState(100);
  const navigateToSpends = (defaultT: string) => {
    setDefaultTab(defaultT);
    setDashboardCurrentPage(DASHBOARDPAGES.SPENDS);
  };

  const navigateToGoalDetails = (goalName: string) => {
    setGoalName(goalName);
    setDashboardCurrentPage(DASHBOARDPAGES.GOALDETAILS);
  };

  const [accountsFetched, setAccountsFetched] = useState(false);
  const onNudgeClick = (nudgeToDisplay: Nudge) => {
    setDrawerNudge(nudgeToDisplay);
    setNudgeDrawerOpen(true);
  };
  const onNudgeCtaClicked = (passedView: any) => {
    setNudgeDrawerOpen(false);
    setDashboardCurrentPage(DASHBOARDPAGES.HOME);
    setDefaultHomeTab(passedView);
  };

  // Define the polling function
  const pollAccountsInfo = async () => {
    let noOfRetries = 0;

    let percentL = 10;

    while (true) {
      try {
        const response = await checkStatusOfConsent({
          userId: getUserId(),
          referenceId: getReferenceId(),
        });

        // Check if the response meets your criteria
        if (
          (response && response.data && response.data.accounts.length > 0) ||
          noOfRetries >= 10
        ) {
          setAccounts(response.data.accounts);
          setPercent(50);
          setAccountsFetched(true);
          break;
        }
      } catch (error) {
        console.error('API call failed:', error);
      }
      // if (noOfRetries >= 10) {
      //   break;
      // }

      if (percentL < 40) {
        percentL = percentL + 10;
      }

      setPercent(percentL);
      noOfRetries = noOfRetries + 1;

      // Wait for a specified amount of time before making the next request
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Wait 3 seconds before retrying
    }
  };

  // useEffect(() => {
  //   if (accountsFetched) fetchAccounts();
  // }, [accountsFetched]);

  // Define the polling function
  const fetchData = async () => {
    let noOfRetries = 0;
    let percentL = 10;

    while (true) {
      try {
        const response = await getData({
          userId: getUserId(),
          dataAttributes: [
            'ACCOUNT_PROFILES',
            'AVG_SALARY',
            'CREDIT_DEBIT_RATIO',
            'CLOSING_BALANCE',
            'ACCOUNT_WISE_ANALYSIS',
          ],
        });

        // Check if the response meets your criteria
        if ((response && response.data) || noOfRetries >= 10) {
          break;
        }
      } catch (error) {
        console.error('API call failed:', error);
      }

      if (percentL < 80) {
        percentL = percentL + 10;
      }

      setPercent(percentL);
      // if (noOfRetries > 10) {
      //   break;
      // }

      noOfRetries = noOfRetries + 1;
      // Wait for a specified amount of time before making the next request
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Wait 3 seconds before retrying
    }
  };

  const fetchAccounts = async () => {
    await getAccounts({ userId: getUserId() }).catch(() => {});
    await fetchData().catch(() => {});

    setPercent(100);
    setTimeout(() => {
      navigateToHome();
      setIsLoading(false);
    }, 2000);
  };

  // useEffect(() => {
  //   setIsLoading(true);
  //   fetchAccounts();
  //   // if (!areApprovedConsentsAvailable()) {
  //   //   pollAccountsInfo();
  //   // } else {
  //   //   fetchAccounts();
  //   // }
  // }, []);

  const navigateToPortfolio = (type: string) => {
    setType(type);
    setDashboardCurrentPage(DASHBOARDPAGES.PORTFOLIO);
  };

  const navigateToHome = (isGoalsBack: boolean = false) => {
    if (isGoalsBack === true) {
      setDefaultHomeTab('goals');
    } else {
      if (defaultHomeTab) {
        setDefaultHomeTab('assets');
      }
    }
    setDashboardCurrentPage(DASHBOARDPAGES.HOME);
  };

  const navigateToCalendarView = () => {
    setDashboardCurrentPage(DASHBOARDPAGES.CALENDAR);
  };

  const navigateToLiabilitiesView = () => {
    setDashboardCurrentPage(DASHBOARDPAGES.LIABILITIES);
  };

  const navigateToGarage = () => {
    setDashboardCurrentPage(DASHBOARDPAGES.GARAGE);
  };

  const renderDashboardPage = () => {
    switch (dashBoardCurrentPage) {
      case DASHBOARDPAGES.HOME:
        return (
          <Home defaultView={defaultHomeTab ? defaultHomeTab : 'assets'} />
        );
      case DASHBOARDPAGES.SPENDS:
        return (
          <Spends
            onBack={() => {
              navigateToHome();
            }}
            defaultTab={defaultTab}
          />
        );
      case DASHBOARDPAGES.PORTFOLIO:
        return (
          <Portfolio
            onBack={() => {
              navigateToHome();
            }}
            type={type}
          />
        );
      case DASHBOARDPAGES.CALENDAR:
        return <Calendar onBack={navigateToHome} />;
      case DASHBOARDPAGES.LIABILITIES:
        return <LiabilitiesView onBack={navigateToHome} />;
      case DASHBOARDPAGES.GOALDETAILS:
        return (
          <GoalDetails
            name={goalName}
            onBack={() => {
              navigateToHome(true);
            }}
          />
        );
      case DASHBOARDPAGES.GARAGE:
        return <Garage onBack={navigateToHome} />;
    }
  };

  return (
    <DashboardContext.Provider
      value={{
        navigateToSpends,
        navigateToPortfolio,
        navigateToGoalDetails,
        setIsWhyAAModalOpen,
        setPortfolioList,
        portfolioList,
        navigateToCalendarView,
        navigateToLiabilitiesView,
        navigateToGarage,
        currentMetaData,
        setCurrentMetaData,
        setIsDetailedTransactionSheetOpen,
        isDetailedTransactionSheetOpen,
        goals,
        setGoals,
        listOfItemsBudget,
        setListOfItemsBudget,
        nudgeDrawerOpen,
        setNudgeDrawerOpen,
        drawerNudge,
        setDrawerNudge,
        onNudgeClick,
        onNudgeCtaClicked,
        pausedAccounts,
        setPausedAccounts,
        revokedAccounts,
        setRevokedAccounts,
      }}
    >
      {false ? (
        <Result
          style={{
            position: 'fixed',
            inset: 0,
            height: '20rem',
            width: '100%',
            margin: 'auto',
          }}
          icon={
            <Progress
              type='dashboard'
              steps={8}
              percent={percent}
              trailColor='rgba(0, 0, 0, 0.06)'
              strokeWidth={20}
            />
          }
          title={`${
            percent === 100 ? 'Data fetch completed' : 'Fetching your data...'
          }`}
          subTitle='It may take 1-5 minutes, please wait.'
        />
      ) : (
        <div className={styles.dashboard_root}>
          <div className={styles.rootHeader}>
            <Typography.Text
              style={{ fontWeight: 600, marginLeft: '10px', fontSize: 18 }}
            >
              {greetUser()}
              <Typography.Text
                style={{ color: 'rgb(0, 46, 220)', fontSize: 18 }}
              >
                {' '}
                {getUserName()}
              </Typography.Text>
            </Typography.Text>
            <img src='/images/goodBank.png' width={160} />
          </div>
          <>{renderDashboardPage()}</>
          <Sheet
            style={{ zIndex: 100 }}
            isOpen={isWhyAAModalOpen}
            onClose={() => {
              setIsWhyAAModalOpen(false);
            }}
            detent='content-height'
            disableScrollLocking={true}
          >
            <Sheet.Container>
              <Sheet.Header />
              <Sheet.Content>
                <WhyAA />
              </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop
              onTap={() => {
                setIsWhyAAModalOpen(false);
              }}
            />
          </Sheet>
          {isDetailedTransactionSheetOpen ? <DetailedTransaction /> : <></>}
          <Modal
            open={nudgeDrawerOpen}
            onCancel={() => setNudgeDrawerOpen(false)}
            footer={null}
            centered
            width={480}
            closeIcon={<CloseOutlined style={{ color: '#fff' }} />}
            styles={{
              content: { padding: 0, overflow: 'hidden', borderRadius: 16 },
              header: { display: 'none' },
              body: { padding: 0 },
            }}
          >
            {drawerNudge && <NudgeDetails nudge={drawerNudge} />}
          </Modal>
        </div>
      )}
    </DashboardContext.Provider>
  );
};

export default Dashboard;
